module.exports = __webpack_public_path__ + "./fonts/icomoon.605e89.ttf";